import { FC, Fragment } from 'react';

import { Redirect, useRoute } from '@core/navigation';
import {
  AnalyticsCategory,
  AnalyticsPageName,
  RoutePath,
} from '@common/constants';
import {
  Button,
  Content,
  Footer,
  Header,
  Page,
  Typography,
  Spinner,
} from '@wearehelpful/ui-kit';
import { ContentfulDocument, useCreateSurvey } from '@helpful/network';
import { useContextSelector } from 'use-context-selector';
import { TrackPageView } from '@wearehelpful/ui-stats';

import { DetailsContext } from '../Details.context';

import { useContentfulDocumentRender } from './Index.hooks';
import { Root } from './Index.style';

export const Index: FC = () => {
  const [, { push }] = useRoute();
  const { render } = useContentfulDocumentRender();

  const { isLoading, mutate } = useCreateSurvey();

  const survey = useContextSelector(DetailsContext, ({ survey }) => survey);

  const loading = useContextSelector(DetailsContext, ({ loading }) => loading);

  const uncomleted = useContextSelector(
    DetailsContext,
    ({ uncomleted }) => uncomleted
  );

  const handleOnNextClick = () => {
    mutate(
      {
        data: {
          slug: survey?.slug,
          response: null,
        },
      },
      {
        onSuccess: ({ data: { id } }) => {
          push({
            path: RoutePath.SURVEYS_DETAILS_QUESTIONS,
            search: { id },
            params: { slug: survey?.slug },
          });
        },
      }
    );
  };

  if (uncomleted) {
    return (
      <Redirect
        search={{ id: uncomleted.id }}
        path={RoutePath.SURVEYS_DETAILS_QUESTIONS}
        params={{ slug: uncomleted.slug }}
      />
    );
  }

  return (
    <TrackPageView
      category={AnalyticsCategory.SURVEY}
      name={AnalyticsPageName.SurveyDetailsIndex}
    >
      <Page>
        <Header>
          <Header.Back defaultHref={RoutePath.SURVEYS} />
        </Header>
        <Content>
          {loading ? (
            <Root>
              <Spinner />
            </Root>
          ) : (
            <Fragment>
              <Content.Subheader>
                <Typography variant="h2" align="center">
                  {survey?.launchScreenTitle}
                </Typography>
              </Content.Subheader>
              <Content.Fixed inset>
                <ContentfulDocument
                  assets={survey?.launchScreenBody.links.assets.block as any}
                  render={render}
                >
                  {survey?.launchScreenBody.json}
                </ContentfulDocument>
              </Content.Fixed>
            </Fragment>
          )}
        </Content>
        {survey && (
          <Footer>
            <Button loading={isLoading} onClick={handleOnNextClick}>
              {survey?.launchScreenCtaLabel}
            </Button>
          </Footer>
        )}
      </Page>
    </TrackPageView>
  );
};
